import { Link } from 'react-router';
import type { TileSize } from '../../../tiles/registry';
import { spokenPeso } from '../../../ui/spokenPeso';
import { BigAmount, safeLine } from '../components/MoneyCards';
import { copy } from '../copy';
import { safeToSpendOf } from '../derive';
import { dayShort } from '../format';
import { useBudgetToday } from '../hooks';
import { FOCUS, LABEL } from '../styles';

/**
 * v0.5: Safe to spend until the next payday, from real money when accounts exist (money on hand
 * + unconfirmed salary − every payment due before payday). A shortfall shows as −₱ in red.
 */
export function SafeToSpendTile({ size = 'wide' }: { size?: TileSize }) {
  const s = useBudgetToday();
  if (!s) return <p className="text-sm text-muted">{copy.loading}</p>;
  const v = safeToSpendOf(s);
  const day = dayShort(v.nextStart).replace(/^\w+, /, '');
  const short = v.amountMinor < 0;
  return (
    <div
      role="group"
      aria-label={`${copy.safeUntil(day)}, ${short ? 'short ' : ''}${spokenPeso(Math.abs(v.amountMinor))}`}
      className="flex flex-col gap-1 [container-type:inline-size]"
    >
      <Link to="/m/budget" className={`inline-flex min-h-11 items-center ${LABEL} ${FOCUS}`}>
        {copy.untilDay(day)}
      </Link>
      <BigAmount minor={v.amountMinor} maxPx={size === 'small' ? 30 : 40} />
      {short ? <p className="text-sm text-destructive">{copy.shortUntil(day)}</p> : null}
      {size !== 'small' ? <p className="text-sm text-muted">{safeLine(v, s)}</p> : null}
    </div>
  );
}
